// export async function get(url, config = {}) {
//     return await axiosApi
//       .get(url, { ...config })
//       .then((response) => response.data);
//   }
import { toast } from "react-toastify";

import axiosAuthInstance from "../axios/axiosAuthInstance";
import refreshAxios from "../axios/refreshTokenInterceptor";

import axiosAuthInstanceImg from "../axios/axiosAuthInstanceImg";


// Use the refresh token interceptor instance which handles 401 and token refresh
const authInstance = refreshAxios;

const unAuthorizedHandler = (err, url) => {
    // Note: 401 errors are now handled by the refresh token interceptor
    // This handler is for other errors
    toast.dismiss();
    if (err.response?.status === 403) {
        toast.error("You don't have permission to perform this action");
    } else if (err.response?.status >= 500) {
        toast.error("Server error. Please try again later.");
    } else if (err.response?.status !== 401) {
        // Don't show toast for 401 as it's handled by the interceptor
        toast.error(err.response?.data?.message || err.message || "Something went wrong");
    }
    // Re-throw error for all status codes so saga can catch them
    throw err;
};

export async function get(url, config = {}) {
    return await authInstance.get(url, { ...config })
        .then((response) => response.data)
        .catch(err => unAuthorizedHandler(err, url));
}

export async function post(url, data, config = {}) {
    return await authInstance.post(url, data, config)
        .then((response) => response.data)
        .catch(err => unAuthorizedHandler(err, url));
}

export async function put(url, data, config = {}) {
    return await authInstance.put(url, data, config)
        .then((response) => response.data)
        .catch(err => unAuthorizedHandler(err, url));
}

export async function patch(url, data, config = {}) {
    return await authInstance.patch(url, data, config)
        .then((response) => response.data)
        .catch(err => unAuthorizedHandler(err, url));
}

export async function del(url, config = {}) {
    return await authInstance.delete(url, { ...config })
        .then((response) => response.data)
        .catch(err => unAuthorizedHandler(err, url));
}

export async function postImg(url, data) {
    try {
        const res = await axiosAuthInstanceImg.post(url, data);
        return res;
    } catch (e) {
        console.log(e);
        unAuthorizedHandler(e);
    }
    // return await axiosAuthInstanceImg.post(url, data)
    //     .then((response) => response.data)
    //     .catch(err => unAuthorizedHandler(err));
}
